import axios from 'axios'
import { getProfileURL, getReferralURL } from './Urls'
import { header } from './Request'

const CACHE_MS = 60 * 1000
const cache = new Map()

const cachedPost = (key, url, body) => {
    const now = Date.now()
    const existing = cache.get(key)
    if (existing && now - existing.createdAt < CACHE_MS) return existing.promise

    const promise = axios.post(url, body, { withCredentials: true, headers: header })
        .catch((error) => {
            cache.delete(key)
            throw error
        })
    cache.set(key, { createdAt: now, promise })
    return promise
}

export const getProfileRequest = () => cachedPost('profile', getProfileURL, { phone_number: '' })

export const getReferralRequest = () => cachedPost(
    `referral:${localStorage.getItem('mobileNumber') || ''}`,
    getReferralURL,
    { phone_number: localStorage.getItem('mobileNumber') }
)

export const clearSessionDataCache = () => cache.clear()
